import { combineReducers } from 'redux';

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const getRandomPlayerIndex = (arr) => getRandomNumber(1, arr.length - 1);

const slotCount = (state = 3) => state;

const isPlaceholder = (
  state = {
    1: false,
    2: false,
    3: false,
  },
  action,
) => {
  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return {
        1: true,
        2: true,
        3: true,
      };
    case 'SET_PLACEHOLDER_STATE':
      return {
        ...state,
        [action.resp]: false,
      };
    default:
      return state;
  }
};

const slotOpenId = (state = null, action) => {
  switch (action.type) {
    case 'SET_SLOT_TO_OPEN':
      return state === action.resp ? null : action.resp;
    // case 'SET_PLAYER_TO_PICKED':
    case 'SET_SLOT_TO_CLOSED':
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return null;
    default:
      return state;
  }
};

const slotClosed = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SLOT_TO_CLOSED':
      return {
        ...state,
        [action.resp]: true,
      };
    case 'SET_SLOT_TO_OPEN':
      return {
        ...state,
        [action.resp]: false,
      };
    default:
      return state;
  }
};

const picked = (
  state = {
    1: null,
    2: null,
    3: null,
  },
  action,
) => {
  switch (action.type) {
    case 'SET_PLAYER_TO_PICKED': {
      const { resp } = action;
      return {
        ...state,
        [resp.id]: state[resp.id] === resp.playerId ? null : resp.playerId,
      };
    }
    case 'SET_PLAYER_PICKS_SUBMITTED': {
      return (action.resp?.picks || []).reduce((acc, entry, index) => {
        const player = entry?.player;
        if (!player?.id) {
          return acc;
        }
        const indexCounter = index + 1;
        return {
          ...acc,
          [indexCounter]: player.id,
        };
      }, {});
    }
    case 'SET_RANDOM_PLAYER_PICKS': {
      const playersBySlot = action.resp?.playersBySlot || {};
      const slotOne = playersBySlot[1] || [];
      const slotTwo = playersBySlot[2] || [];
      const slotThree = playersBySlot[3] || [];
      if (!slotOne.length || !slotTwo.length || !slotThree.length) {
        return state;
      }

      const pickOne = getRandomPlayerIndex(slotOne);
      const pickTwo = getRandomPlayerIndex(slotTwo);
      const pickThree = getRandomPlayerIndex(slotThree);

      return {
        1: slotOne[pickOne].id,
        2: slotTwo[pickTwo].id,
        3: slotThree[pickThree].id,
      };
    }
    case 'CLEAR_ALL_PICKS': {
      return {
        1: null,
        2: null,
        3: null,
      };
    }
    case 'SEND_PLAYER_PICKS_FAILURE':
      return {};
    default:
      return state;
  }
};

const fetchError = (state = null, action) => {
  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_RANDOM_PLAYER_PICKS':
      return null;
    case 'SEND_PLAYER_PICKS_FAILURE':
      return action.err;
    default:
      return state;
  }
};

const picksLocked = (state = false, action) => {
  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;
    case 'CLEAR_ALL_PICKS':
      return false;
    default:
      return state;
  }
};

const picksSubmitted = (state = false, action) => {
  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return true;
    case 'CLEAR_ALL_PICKS':
      return false;
    default:
      return state;
  }
};

const randomPicksSelected = (state = false, action) => {
  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return true;
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_PLAYER_TO_PICKED':
    case 'SET_CURRENT_ROUTE':
      return false;
    default:
      return state;
  }
};

const randomPickCount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return state + 1;
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return 0;
    default:
      return state;
  }
};

const pickClicked = (state = false, action) => {
  switch (action.type) {
    case 'SET_PLAYER_TO_PICKED':
      return true;
    case 'SET_SLOT_TO_CLOSED':
      return false;
    default:
      return state;
  }
};

const picksSentAlready = (state = false, action) => {
  switch (action.type) {
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;
    default:
      return state;
  }
};

const incompletePicksModalOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_INCOMPLETE_PICKS_MODAL_OPEN':
      return true;
    case 'SET_INCOMPLETE_PICKS_MODAL_CLOSED':
      return false;
    case 'RESET_NAVIGATION_MODAL_STATE':
      return false;
    default:
      return state;
  }
};

const pendingNavigation = (state = null, action) => {
  switch (action.type) {
    case 'SET_PENDING_NAVIGATION':
      return action.payload;
    case 'CLEAR_PENDING_NAVIGATION':
      return null;
    case 'RESET_NAVIGATION_MODAL_STATE':
      return null;
    default:
      return state;
  }
};

const submissionError = (state = null, action) => {
  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'CLEAR_SUBMISSION_ERROR':
      return null;
    case 'SEND_PLAYER_PICKS_FAILURE':
      return action.err || null;
    case 'CLEAR_ALL_PICKS':
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  fetchError,
  isPlaceholder,
  slotCount,
  slotOpenId,
  slotClosed,
  picked,
  picksLocked,
  picksSubmitted,
  picksSentAlready,
  randomPicksSelected,
  randomPickCount,
  pickClicked,
  incompletePicksModalOpen,
  pendingNavigation,
  submissionError,
});
